import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LottieModule } from 'ngx-lottie';
import { AppMaterialModule } from 'src/app/app-material.module';
import { BottomSheetComponent } from './components/bottom-sheet/bottom-sheet.component';
import { ErrorScreenComponent } from './components/error-screen/error-screen.component';
import { InputComponent } from './components/input/input.component';
import { PurchaseSummaryComponent } from './components/purchase-summary/purchase-summary.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { DialogRetrieveDataComponent } from './dialogs/dialog-retrieve-data/dialog-retrieve-data.component';
import { DialogTermsComponent } from './dialogs/dialog-terms/dialog-terms.component';
import { NotificationComponent } from './notification/notification.component';
import { SafePipe } from './pipes/safe.pipe';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CustomCurrencyPipe } from 'src/assets/pipes/custom-currency.pipe';
import { ImageUploadComponent } from './components/anexos/image-upload/image-upload.component';
import { ImagePreviewComponent } from './components/anexos/image-preview/image-preview.component';
import { TelefoneIntlComponent } from './components/telefone-intl/telefone-intl.component';
import { NgxMaskModule } from 'ngx-mask';

export function playerFactory() {
  return import('lottie-web');
}
@NgModule({
  declarations: [
    InputComponent,
    DialogTermsComponent,
    DialogRetrieveDataComponent,
    NotificationComponent,
    PurchaseSummaryComponent,
    StepperComponent,
    BottomSheetComponent,
    ErrorScreenComponent,
    ImagePreviewComponent,
    SafePipe,
    CustomCurrencyPipe,
    TelefoneIntlComponent
  ],
  exports: [
    InputComponent,
    PurchaseSummaryComponent,
    StepperComponent,
    BottomSheetComponent,
    ErrorScreenComponent,
    SafePipe,
    CustomCurrencyPipe,
    TelefoneIntlComponent
  ],
  providers: [
    PurchaseSummaryComponent,
    StepperComponent,
    BottomSheetComponent,
    ErrorScreenComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    AppMaterialModule,
    FormsModule,
    CKEditorModule,
    FlexLayoutModule,
    NgxMaskModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
  ],
  entryComponents: [DialogTermsComponent, DialogRetrieveDataComponent, NotificationComponent],
})
export class SharedModule {}
